import { validatePostcode } from '../address_helpers';
import { FormattedMessage } from 'react-intl';
import React from 'react';

const CurrencyFormatter = require('currency-formatter');

const formatCurrency = (number, currencyCode) => {
  return CurrencyFormatter.format(number, { code: currencyCode });
};

const getTotalCost = (planTypes, activePlanType, verifiedCoupon, currencyCode) => {
  const activePlan = planTypes.find(planType => planType.planCode === activePlanType);
  let totalCost = activePlan.priceTotal;
  if (verifiedCoupon && verifiedCoupon.discountedPricePerYear && activePlanType !== 1) {
    totalCost = verifiedCoupon.discountedPricePerYear;
  }
  return formatCurrency(Number(totalCost), currencyCode);
};

const getTotalBaseAnnualCost = (planTypes, activePlanType, currencyCode) => {
  const activePlan = planTypes.find(planType => planType.planCode === activePlanType);
  const totalCost = activePlan.priceTotal;
  return formatCurrency(Number(totalCost), currencyCode);
};

const validatePaymentForm = (name, value, errors, text) => {
  switch (name) {
    case 'name':
      if (value.length < 1) {
        errors[name] = text.name.validation.generic;
      } else if (value.split(' ').length < 2) {
        errors[name] = <FormattedMessage defaultMessage="Cardholder's name must include a valid last name." />;
      } else {
        errors[name] = '';
      }
      break;
    case 'cvv':
      // CardValidator provides a max code size if we want to use it here but for some reason it isn't implemented
      errors[name] = value.length > 4 || value.length < 3 ? text.cvv.validation.generic : '';
      break;
    case 'postalCode':
      errors[name] = !validatePostcode(value, 'INTL') || value.length === 0 ? text.postalCode.validation.generic : '';
      break;
    default:
      break;
  }

  return { [name]: value, errors };
};

export { validatePaymentForm, formatCurrency, getTotalCost, getTotalBaseAnnualCost };
